<script>
  import BaseAnswer from '@assessment/shared/BaseAnswers';

  export default {
    name: 'Answers',

    props: {
      currentEmail: {
        type: Object,
        required: true,
      },
      info: {
        type: Object,
      },
    },
    components: {
      BaseAnswer,
    },
  };
</script>
<template>
  <base-answer :current-email="currentEmail" :enable-auto-save="true">
    <div
      class="row pl-20 pr-20 pb-20"
      slot-scope="{ answers, isSaving, answerEvents, pickedAnswers }"
    >
      <hr />
      <div class="col-md-12 well questions mb-0">
        <div class="col-md-105">
          <!-- Multi answer question -->
          <template v-if="currentEmail.FK_questionTypeKey === 2">
            <span
              ><b> <i>Choose all responses that apply.</i></b></span
            >
            <template v-for="answer in answers">
              <div class="radio answer-choice" :key="answer.answerKey">
                <label :for="`f-option-${answer.answerKey}`" class="multi-answer-label">
                  <input
                    name="answer"
                    :id="`f-option-${answer.answerKey}`"
                    type="checkbox"
                    :value="answer.answerKey"
                    :checked="pickedAnswers.includes(answer.answerKey)"
                    v-on="answerEvents.multi"
                    :disabled="
                      currentEmail.maxAnswerCount > 1 &&
                      currentEmail.maxAnswerCount <= pickedAnswers.length &&
                      !pickedAnswers.includes(answer.answerKey)
                    "
                  />
                  <span v-html="answer.nameTagKey" class="ml-5"></span>
                </label>
              </div>
            </template>
          </template>
          <!-- Single answer question -->
          <template v-else-if="currentEmail.FK_questionTypeKey === 1">
            <template v-for="answer in answers">
              <div class="radio answer-choice" :key="answer.answerKey">
                <label class="ml-0" :for="`f-option-${answer.answerKey}`">
                  <input
                    :name="`answer`"
                    :id="`f-option-${answer.answerKey}`"
                    type="radio"
                    :value="answer.answerKey"
                    v-on="answerEvents.single"
                    :checked="pickedAnswers === answer.answerKey"
                  />
                  <span v-html="answer.nameTagKey"></span>
                </label>
              </div>
            </template>
          </template>
          <div class="save-container">
            <span v-show="isSaving" class="flash save-text">Saving...</span>
          </div>
        </div>
      </div>
    </div>
  </base-answer>
</template>
<style lang="scss" scope>
  .multi-answer-label {
    display: flex;
    margin-left: -20px;
  }
  .save-container {
    height: 10px;
  }
</style>
